
import { Component, Prop, Vue } from 'vue-property-decorator'
import ConfirmDialog from "@/components/ConfirmDialog.vue"

@Component({
  filters: {
  },
  components: {
    ConfirmDialog
  }
})
export default class DeleteProjectDialog extends Vue {
  private dialog = false

  @Prop({ required: true })
  private hasRunningTracking!: boolean

  @Prop({ required: true })
  private confirmTitleKey!: string

  @Prop({ required: true })
  private confirmTextKey!: string
}
